import {
  SET_CHALLENGE_LIST,
  SET_CHALLENGE_QUIZ_LIST,
  SET_QUIZ_CORRECT_RESULT,
  SAVE_QUIZ_PARTICIPATION_START,
  SAVE_QUIZ_PARTICIPATION_SUCCESS,
  SAVE_QUIZ_PARTICIPATION_FAILURE,
  CLEAR_CHALLENGE_DATA
} from '../actions/challengeActions';

const initialState = {
  challengeList: [],
  challengeQuizMap: {}, // { [challengeId]: [퀴즈목록] }
  challengeParticipationMap: {}, // { [challengeId]: [참여정보목록] }
  quizCorrectResultMap: {}, // { [challengeId_quizNo]: [정답쿼리실행결과] }
  participationSaving: false, // 참여 저장 중 여부
  participationSaveError: null, // 참여 저장 에러
  participationSaveResult: null // 참여 저장 결과
};

export default function challengeReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CHALLENGE_LIST:
      console.log('Redux: SET_CHALLENGE_LIST 액션 처리');
      console.log('payload:', action.payload);
      return { ...state, challengeList: action.payload };
    case SET_CHALLENGE_QUIZ_LIST:
      console.log('=== Redux: SET_CHALLENGE_QUIZ_LIST 액션 처리 ===');
      console.log('action.payload:', action.payload);
      console.log('challengeId:', action.payload.challengeId);
      console.log('quizList:', action.payload.quizList);
      console.log('quizList 길이:', action.payload.quizList?.length);
      
      const newQuizMap = {
        ...state.challengeQuizMap,
        [action.payload.challengeId]: action.payload.quizList
      };
      console.log('새로운 challengeQuizMap:', newQuizMap);
      
      return {
        ...state,
        challengeQuizMap: newQuizMap
      };
    case SET_QUIZ_CORRECT_RESULT:
      console.log('=== Redux: SET_QUIZ_CORRECT_RESULT 액션 처리 ===');
      console.log('action.payload:', action.payload);
      console.log('challengeId:', action.payload.challengeId);
      console.log('quizNo:', action.payload.quizNo);
      console.log('correctResult 길이:', action.payload.correctResult?.length);

      const correctResultKey = `${action.payload.challengeId}_${action.payload.quizNo}`;

      // 오류가 있으면 오류 정보를 저장, 성공이면 결과를 저장
      const resultValue = action.payload.error
        ? { error: action.payload.error }
        : action.payload.correctResult;

      const newCorrectResultMap = {
        ...state.quizCorrectResultMap,
        [correctResultKey]: resultValue
      };
      console.log('새로운 quizCorrectResultMap:', newCorrectResultMap);

      return {
        ...state,
        quizCorrectResultMap: newCorrectResultMap
      };
    case 'SET_CHALLENGE_QUIZ_PARTICIPATION':
      return {
        ...state,
        challengeParticipationMap: {
          ...state.challengeParticipationMap,
          [action.payload.challengeId]: action.payload.participationList
        }
      };
    case SAVE_QUIZ_PARTICIPATION_START:
      return {
        ...state,
        participationSaving: true,
        participationSaveError: null,
        participationSaveResult: null
      };
    case SAVE_QUIZ_PARTICIPATION_SUCCESS:
      console.log('Redux: SAVE_QUIZ_PARTICIPATION_SUCCESS 액션 처리');
      console.log('payload:', action.payload);
      return {
        ...state,
        participationSaving: false,
        participationSaveError: null,
        participationSaveResult: action.payload
      };
    case SAVE_QUIZ_PARTICIPATION_FAILURE:
      console.error('Redux: SAVE_QUIZ_PARTICIPATION_FAILURE 액션 처리');
      console.error('error:', action.payload);
      return {
        ...state,
        participationSaving: false,
        participationSaveError: action.payload,
        participationSaveResult: null
      };
    case 'CLEAR_QUIZ_CORRECT_RESULTS':
      console.log('Redux: CLEAR_QUIZ_CORRECT_RESULTS 액션 처리:', action.payload.challengeId);

      // 해당 챌린지의 정답 쿼리 결과만 삭제
      const newQuizCorrectResultMapAfterClear = { ...state.quizCorrectResultMap };
      const challengePrefix = `${action.payload.challengeId}_`;

      Object.keys(newQuizCorrectResultMapAfterClear).forEach(key => {
        if (key.startsWith(challengePrefix)) {
          delete newQuizCorrectResultMapAfterClear[key];
        }
      });

      return {
        ...state,
        quizCorrectResultMap: newQuizCorrectResultMapAfterClear
      };
    case 'CLEAR_QUIZ_CORRECT_RESULT_ERROR':
      console.log('Redux: CLEAR_QUIZ_CORRECT_RESULT_ERROR 액션 처리:', action.payload);

      // 특정 퀴즈의 에러 상태만 삭제
      const errorResultKey = `${action.payload.challengeId}_${action.payload.quizNo}`;
      const newQuizCorrectResultMapAfterErrorClear = { ...state.quizCorrectResultMap };
      delete newQuizCorrectResultMapAfterErrorClear[errorResultKey];

      return {
        ...state,
        quizCorrectResultMap: newQuizCorrectResultMapAfterErrorClear
      };
    case CLEAR_CHALLENGE_DATA:
      console.log('Redux: CLEAR_CHALLENGE_DATA 액션 처리 - 모든 챌린지 데이터 초기화');
      return initialState;
    default:
      return state;
  }
} 